import React from "react";

import { useTranslation } from "utils";

import { AlertBanner } from "components";

// Dismissible banner shown on step 1 after an import from field management. A field-only
// import (no rotation available) asks the user to add the rotation themselves.
// Dismissal is persisted into the onboarding draft key by the parent.
export const ImportBanner = ({ rotationImported, onDismiss }: { rotationImported: boolean; onDismiss: () => void }) => {
  const { t } = useTranslation("scenarioAnalysis");

  return (
    <AlertBanner
      dataTestId="onboarding-import-banner"
      type="success"
      iconName="tabler/confetti"
      iconAlign="start"
      closeable
      onClose={onDismiss}
      description={t(rotationImported ? "onboarding.step1.importBanner" : "onboarding.step1.importBannerFieldOnly")}
      className="margin-bottom-150"
    />
  );
};
